import { ExternalConnectionsProviders } from '@griply/types';
import { getProviderNameKey } from '@griply/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from 'shared/components/ui/button';
import { ConfirmDialog } from 'shared/components/ui/confirm-dialog';

export type EventMoveBlockedDialogProps = {
  provider: ExternalConnectionsProviders;
  // absent on an older backend response — the message then has no action to offer
  url: string | undefined;
  onClose: () => void;
};

// Raised when a drag lands on an event someone else organises: the provider only lets the
// organiser move a meeting, so the answer is a link to where the change can actually be made.
export const EventMoveBlockedDialog: React.FC<EventMoveBlockedDialogProps> = ({
  provider,
  url,
  onClose,
}) => {
  const { t } = useTranslation();

  const providerName = t(getProviderNameKey(provider));

  const onOpenProvider = () => {
    url && window.open(url, '_blank', 'noreferrer');
    onClose();
  };

  return (
    <ConfirmDialog
      open
      title={t('forms.event.move-blocked.title')}
      message={t('forms.event.move-blocked.description', {
        provider: providerName,
      })}
      confirmLabel={t('forms.event.move-blocked.open', {
        provider: providerName,
      })}
      confirmColor={Colors.Primary}
      hideConfirm={!url}
      cancelLabel={url ? t('general.cancel') : t('general.ok')}
      onConfirm={onOpenProvider}
      onCancel={onClose}
    />
  );
};
